import React, { Component } from 'react';
import styled from 'styled-components';
import { media } from '../../helpers/styleConstants';
import { connect } from 'react-redux';
import { Checkbox } from 'rmwc/Checkbox';
import { Text } from '../../components/Text';
import { LoadingBar } from '../../components/util/LoadingBar';
import Hint from '../../components/ModuleDrawer/Hint';
import { DynamicWrapper } from '../../components/util/DynamicWrapper';
import { SelectControl } from '../../components/controls/SelectControl';
import { TextFieldHelperText } from 'rmwc';

import { backOnboarding, continueOnboarding, pathAware } from '../../actions/onboardingActions';

const DebtCheckBoxes = styled.div`
  width: 97%;
  display: flex;
  justify-content: space-between;

  ${media.phoneOnly`
    flex-direction: column;
    justify-content: flex-start;
  `};
`;

const StyledAnswerRow = styled.div`
  width: 80%;
`;

const creditCardSpec = {
  field_type: 'single_choice',
  options: [0, 2500, 7500, 12500, 17500, 25000, 40000],
  option_data: {
    '0': { label: 'No Debt' },
    '2500': { label: '$1,000-$4,999' },
    '7500': { label: '$5,000-$9,999' },
    '12500': { label: '$10,000-$14,999' },
    '17500': { label: '$15,000-$19,999' },
    '25000': { label: '$20,000-$29,999' },
    '40000': { label: '$30,000+' },
  },
};

const autoAndStudentSpec = {
  field_type: 'single_choice',
  options: [0, 2500, 7500, 17500, 37500, 62500, 100000],
  option_data: {
    '0': { label: 'No Debt' },
    '2500': { label: '$1,000-$4,999' },
    '7500': { label: '$5,000-$9,999' },
    '17500': { label: '$10,000-$24,999' },
    '37500': { label: '$25,000-$49,999' },
    '62500': { label: '$50,000-$74,999' },
    '100000': { label: '$75,000+' },
  },
};

const secondMorgageSpec = {
  field_type: 'single_choice',
  options: [0, 5000, 17500, 37500, 75000, 125000, 200000],
  option_data: {
    '0': { label: 'No Debt' },
    '5000': { label: '$1,000-$9,999' },
    '17500': { label: '$10,000-$24,999' },
    '37500': { label: '$25,000-$49,999' },
    '75000': { label: '$50,000-$99,999' },
    '125000': { label: '$100,000-$149,999' },
    '200000': { label: '$150,000+' },
  },
};

const otherSpec = {
  field_type: 'single_choice',
  options: [0, 2500, 7500, 15000, 25000, 42500, 75000],
  option_data: {
    '0': { label: 'No Debt' },
    '2500': { label: '$1,000-$4,999' },
    '7500': { label: '$5,000-$9,999' },
    '15000': { label: '$10,000-$19,999' },
    '25000': { label: '$20,000-$29,999' },
    '42500': { label: '$30,000-$49,999' },
    '75000': { label: '$50,000+' },
  },
};

const debtTypes = [
  {
    field: 'creditCards',
    label: 'Credit Card',
    text: 'If you have debt on more than one card, provide a rough total.',
    spec: creditCardSpec,
  },
  {
    field: 'autoLoans',
    label: 'Auto Loan',
    text: 'If you have more than one loan outstanding, provide a rough total.',
    spec: autoAndStudentSpec,
  },
  {
    field: 'studentLoans',
    label: 'Student Loan',
    text: 'If you have more than one loan outstanding, provide a rough total.',
    spec: autoAndStudentSpec,
  },
  {
    field: 'secondMortgage',
    label: '2nd Mortgage/HELOC',
    text: 'Include any debt on your primary residence beyond your 1st mortgage. Ignore other properties for now.',
    spec: secondMorgageSpec,
  },
  {
    field: 'other',
    label: 'Other Personal Debt',
    text: 'If you have more than one loan outstanding, provide the rough total.',
    spec: otherSpec,
  },
];

class DebtAmounts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      creditCards:
        props.qna_hash.creditCardsDebtAmount && parseInt(props.qna_hash.creditCardsDebtAmount.answer) ? true : false,
      creditCardsDebtAmount: props.qna_hash.creditCardsDebtAmount ? props.qna_hash.creditCardsDebtAmount.answer : '0',
      autoLoans:
        props.qna_hash.autoLoansDebtAmount && parseInt(props.qna_hash.autoLoansDebtAmount.answer) ? true : false,
      autoLoansDebtAmount: props.qna_hash.autoLoansDebtAmount ? props.qna_hash.autoLoansDebtAmount.answer : '0',
      studentLoans:
        props.qna_hash.studentLoansDebtAmount && parseInt(props.qna_hash.studentLoansDebtAmount.answer) ? true : false,
      studentLoansDebtAmount: props.qna_hash.studentLoansDebtAmount
        ? props.qna_hash.studentLoansDebtAmount.answer
        : '0',
      secondMortgage:
        props.qna_hash.secondMortgageDebtAmount && parseInt(props.qna_hash.secondMortgageDebtAmount.answer)
          ? true
          : false,
      secondMortgageDebtAmount: props.qna_hash.secondMortgageDebtAmount
        ? props.qna_hash.secondMortgageDebtAmount.answer
        : '0',
      other: props.qna_hash.otherDebtAmount && parseInt(props.qna_hash.otherDebtAmount.answer) ? true : false,
      otherDebtAmount: props.qna_hash.otherDebtAmount ? props.qna_hash.otherDebtAmount.answer : '0',
    };
  }

  componentDidMount() {
    this.props.pathAware('creditCardsDebtAmount');
  }

  componentWillReceiveProps(props) {
    if (props.qna_hash.creditCardsDebtAmount) {
      this.setState({
        creditCards: !!parseInt(props.qna_hash.creditCardsDebtAmount.answer),
        creditCardsDebtAmount: props.qna_hash.creditCardsDebtAmount.answer,
        autoLoans: !!parseInt(props.qna_hash.autoLoansDebtAmount.answer),
        autoLoansDebtAmount: props.qna_hash.autoLoansDebtAmount.answer,
        studentLoans: !!parseInt(props.qna_hash.studentLoansDebtAmount.answer),
        studentLoansDebtAmount: props.qna_hash.studentLoansDebtAmount.answer,
        secondMortgage: !!parseInt(props.qna_hash.secondMortgageDebtAmount.answer),
        secondMortgageDebtAmount: props.qna_hash.secondMortgageDebtAmount.answer,
        other: !!parseInt(props.qna_hash.otherDebtAmount.answer),
        otherDebtAmount: props.qna_hash.otherDebtAmount.answer,
      });
    }
  }

  _onContinue = () => {
    const { onContinue, qna_hash, qna_stack } = this.props;

    this.props
      .continueOnboarding(qna_stack, qna_hash, {
        creditCardsDebtAmount: {
          question: 'Credit Card debt',
          answer: this.state.creditCardsDebtAmount,
        },
        autoLoansDebtAmount: {
          question: 'Auto Loan debt',
          answer: this.state.autoLoansDebtAmount,
        },
        studentLoansDebtAmount: {
          question: 'Student Loan debt',
          answer: this.state.studentLoansDebtAmount,
        },
        secondMortgageDebtAmount: {
          question: '2nd Mortgage/HELOC debt',
          answer: this.state.secondMortgageDebtAmount,
        },
        otherDebtAmount: {
          question: 'Other personal debt',
          answer: this.state.otherDebtAmount,
        },
      })
      .then(onContinue);
  };

  _onBack = () => {
    this.props.backOnboarding(this.props.qna_stack).then(this.props.onBack);
  };

  onChange = (evt, field) => {
    this.setState({ [field]: evt.target.checked });
  };

  onDebtAmountChange = (evt, field) => {
    this.setState({ [field]: evt.target.value });
  };

  debtCheckbox = option => (
    <Checkbox
      id={option.field}
      className="mr-2"
      key={option.field}
      onChange={e => {
        this.onChange(e, option.field);
      }}
      checked={this.state[option.field]}
      label={option.label}
    />
  );

  debtAmountInput = option =>
    this.state[option.field] && (
      <div
        key={`${option.field}Amount`}
        style={{ width: '100%', borderTop: '1px solid #e0e0e0', display: 'flex', justifyContent: 'center' }}
      >
        <div className="flow-textfield" style={{ width: '85%' }}>
          <Text className="mt-2" use="body2">
            {option.label}
          </Text>
          <Text className="ml-2 mb-0" use="body1">
            {option.text}
          </Text>
          <StyledAnswerRow>
            <SelectControl
              id={`${option.field}Amount`}
              className="mt-0 ml-2"
              label="Debt Amount"
              value={this.state[`${option.field}DebtAmount`]}
              spec={option.spec}
              onChange={evt => this.onDebtAmountChange(evt, `${option.field}DebtAmount`)}
            />
          </StyledAnswerRow>
          <TextFieldHelperText className="ml-2 mb-4" persistent>
            The total amount you owe across all your accounts
          </TextFieldHelperText>
        </div>
      </div>
    );

  render() {
    const { qna_hash, wrapper } = this.props;

    if (!qna_hash.hasPartner) {
      return <LoadingBar />;
    }

    return (
      <DynamicWrapper
        style={{ width: '100%' }}
        wrapper={wrapper}
        onContinue={this._onContinue}
        onBack={this._onBack}
        canContinue
        helperText={<Hint>Don't worry about getting it perfect! You'll be able to update this information later</Hint>}
      >
        <div style={{ width: '90%', display: 'flex', justifyContent: 'center' }}>
          <Text use="headline6">What kinds of debt do you have, and how much?</Text>
        </div>
        <div
          style={{ width: '90%', margin: 'auto', display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
        >
          <Text className="mb-0" use="body1">
            If you're not sure about the exact numbers, feel free to guess, or leave the default answer!
          </Text>
        </div>
        <DebtCheckBoxes>{debtTypes.map(this.debtCheckbox)}</DebtCheckBoxes>
        {debtTypes.map(this.debtAmountInput)}
      </DynamicWrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    qna_hash: state.onboarding.qna_hash,
    qna_stack: state.onboarding.qna_stack,
  };
}

export default connect(mapStateToProps, { backOnboarding, continueOnboarding, pathAware })(DebtAmounts);
